// components/Modals/ContentModal/components/LoadingOverlay.js
import React from 'react';

function LoadingOverlay({ 
    isLoading, 
    uploadProgress, 
    editingContentId,
    mediaFiles 
}) {
    if (!isLoading) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            backdropFilter: 'blur(3px)'
        }}>
            <div style={{
                background: 'white',
                borderRadius: '16px',
                padding: '40px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '25px',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
                minWidth: '400px'
            }}>
                {/* Yükleme animasyonu */}
                <div style={{ display: 'flex', gap: '12px' }}>
                    <span style={{
                        width: '15px',
                        height: '15px',
                        borderRadius: '50%',
                        backgroundColor: '#667eea',
                        animation: 'pulse 1.4s infinite ease-in-out',
                        animationDelay: '0s'
                    }} />
                    <span style={{
                        width: '15px',
                        height: '15px',
                        borderRadius: '50%',
                        backgroundColor: '#667eea',
                        animation: 'pulse 1.4s infinite ease-in-out',
                        animationDelay: '0.2s'
                    }} />
                    <span style={{
                        width: '15px',
                        height: '15px',
                        borderRadius: '50%',
                        backgroundColor: '#667eea',
                        animation: 'pulse 1.4s infinite ease-in-out',
                        animationDelay: '0.4s'
                    }} />
                </div>
                
                {/* Başlık ve açıklama */}
                <div style={{ textAlign: 'center' }}>
                    <h3 style={{ 
                        margin: '0 0 10px 0',
                        color: '#333',
                        fontSize: '20px',
                        fontWeight: '600'
                    }}>
                        {uploadProgress > 0 ? '📤 Medya Yükleniyor...' : 
                         editingContentId ? '📝 İçerik Güncelleniyor...' : '📤 İçerik Yayınlanıyor...'}
                    </h3>
                    <p style={{ 
                        margin: 0,
                        color: '#666',
                        fontSize: '14px'
                    }}>
                        {uploadProgress > 0 
                            ? 'Medya dosyaları sunucuya yükleniyor...'
                            : 'Lütfen bekleyiniz, içerik ekleniyor...'}
                    </p>
                </div>
                
                {/* Progress Bar - Sadece upload varsa göster */}
                {uploadProgress > 0 && (
                    <div style={{ width: '100%' }}>
                        <div style={{
                            width: '100%',
                            height: '30px',
                            background: '#f0f0f0',
                            borderRadius: '15px',
                            overflow: 'hidden',
                            position: 'relative'
                        }}>
                            <div style={{
                                width: `${uploadProgress}%`,
                                height: '100%',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                transition: 'width 0.3s ease',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                fontSize: '14px',
                                fontWeight: 'bold'
                            }}>
                                {uploadProgress}%
                            </div>
                        </div>
                        
                        {/* Yükleme detayları */}
                        <div style={{
                            marginTop: '10px',
                            textAlign: 'center',
                            fontSize: '13px',
                            color: '#888'
                        }}>
                            {uploadProgress < 100 
                                ? `Yükleniyor... ${uploadProgress}%`
                                : 'Yükleme tamamlandı, işleniyor...'}
                        </div>
                    </div>
                )}
                
                {/* Medya bilgisi */}
                {mediaFiles && mediaFiles.length > 0 && (
                    <div style={{
                        fontSize: '12px',
                        color: '#999',
                        textAlign: 'center'
                    }}>
                        {mediaFiles.length} dosya • 
                        {mediaFiles.reduce((acc, file) => acc + file.size, 0) / (1024 * 1024) < 1
                            ? `${(mediaFiles.reduce((acc, file) => acc + file.size, 0) / 1024).toFixed(0)} KB`
                            : `${(mediaFiles.reduce((acc, file) => acc + file.size, 0) / (1024 * 1024)).toFixed(1)} MB`}
                    </div>
                )}
            </div>
        </div>
    );
}

export default LoadingOverlay;